<div class="modal-content">
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
  <div class="modal-header">
    <h3 class="modal-title font">Datos de baja</h3>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
      <span aria-hidden="true">&times;</span>
    </button>

  </div>

  <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">

    <!-- Formulario datos de baja -->
    <form class="form-modal py-3" [formGroup]="formGroup">
      <div class="row-fields">
        <div class="field field-100">
          <label for="motivoBaja">Motivo de baja <span class="oblig">*</span></label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="motivoBaja" id="motivoBaja" placeholder="Motivo de baja">
              <mat-option *ngFor="let motivo of motivosBaja" [value]="motivo.id">
                {{motivo.descripcion}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="controlHasError('motivoBaja', 'required')">Campo obligatorio</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row-fields">
        <div class="field" [ngClass]="esBajaEnvalora() ? 'field-50' : 'field-100'">
          <label for="anioUltimoDatos">Año últimos datos <span class="oblig">*</span></label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="anioUltimoDatos" id="anioUltimoDatos" placeholder="Año últimos datos">
              <mat-option *ngFor="let anio of arrayAnios" [value]="anio">
                {{anio}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="controlHasError('anioUltimoDatos', 'required')">Campo obligatorio</mat-error>
          </mat-form-field>
        </div>
        <div class="field field-50" *ngIf="esBajaEnvalora()">
          <label for="fechaFinContrato">Fecha fin contrato <span class="oblig">*</span></label>
          <mat-form-field appearance="outline">
            <input matInput [matDatepicker]="datepicker" formControlName="fechaFinContrato">
            <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
            <mat-datepicker #datepicker>
            </mat-datepicker>
            <mat-error *ngIf="controlHasError('fechaFinContrato', 'required')">Campo obligatorio</mat-error>
            <mat-error *ngIf="controlHasError('fechaFinContrato', 'matDatepickerParse')">Formato incorrecto</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row-fields">
        <div class="field field-100">
          <label for="observacionesBaja">Observaciones baja</label>
          <div class="custom-mat-form-field-width">
            <mat-form-field appearance="outline" class="custom-mat-form-field-width">
              <input type="text" matInput formControlName="observacionesBaja" id="observacionesBaja"
                placeholder="Observaciones baja" maxlength="255">
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>

    <!-- FIN Formulario datos de baja -->
  </div>
  <div class="modal-footer actions">
    <div class="note">* Campos Obligatorios</div>
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" data-dismiss="modal" (click)="cerrar()"
        aria-label="Cancelar">Cancelar</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="guardar()"
        aria-label="Guardar">Guardar</button>
    </div>
  </div>
</div>
